import { notification } from 'antd';
import 'antd/dist/antd.css';
import { Auth } from 'aws-amplify';
import { TrackEmailEvents } from 'analytics/helpers/TrackEmailEvents';
import { useCountrySetting } from 'core/services/allCountryDetailsService';
import { saveDeviceToken } from 'core/services/deviceTokenService';
import { initializeMessaging, requestNotificationPermission } from 'core/services/messaging';
import { onMessage } from 'firebase/messaging';
import React, { lazy, Suspense, useEffect } from 'react';
import 'syngenta-digital-cropwise-react-ui-kit/dist/styles/cw-ui-kit.less';
import './api/api';
import { Loader } from './components/loader';
import './main.less';

export const App = () => {
  const { modalDetails, modalDetailsLoader } = useCountrySetting();
  const RouterComponent = lazy(() => import('./AppRouter'));

  useEffect(() => {
    // Notification emails link back with ?action_name=<email-service-name> — track which email drove the click.
    const actionName = new URLSearchParams(window.location.search).get('action_name');
    if (actionName) {
      TrackEmailEvents.trackEmailLinkClicked(actionName);
    }
  }, []);

  useEffect(() => {
    const initializeFCM = async () => {
      // Skip FCM initialization for UAT and production environments
      const env = process.env.REACT_APP_ENV;
      if (env === 'uat' || env === 'prod') {
        console.log(`FCM initialization skipped for environment: ${env}`);
        return;
      }

      try {
        const messaging = await initializeMessaging();
        if (!messaging) {
          console.log('Messaging initialization failed');
          return;
        }
        try {
          // Request permission and get token
          const token = await requestNotificationPermission();
          console.log('FCM Token:', token);
          const authRes = await Auth.currentAuthenticatedUser();
          if (token && authRes?.attributes?.email) {
            saveDeviceToken({
              device_token: token,
              user_email: authRes?.attributes?.email,
            });
          }
        } catch (error) {
          console.log('Skipping Save device token api, ', error);
        }

        // Set up message listener
        onMessage(messaging, (payload) => {
          console.log('Received message:', payload);
          if (Notification.permission === 'granted') {
            const { title, body } = payload.notification || {};
            notification.success({
              message: title,
              description: body,
              placement: 'topRight',
              duration: 2.5,
            });
          }
        });
      } catch (error) {
        console.log('FCM: ', error);
      }
    };
    initializeFCM();
  }, []);
  // Keeping an extra currentAuthenticatedUser+setLdUser here can race and mask the real issue.
  // useEffect(() => {
  //   Auth.currentAuthenticatedUser()
  //     .then((user) => {
  //       let ldUser={
  //         key: user.attributes.sub || user.attributes.email,
  //         email: user.attributes.email,
  //         name: user.attributes.name,
  //         custom: {
  //           country: user?.attributes?.['custom:country_code'],
  //           role: user?.attributes?.['custom:role'],
  //           countryCode:user?.attributes?.['custom:country_code'],
  //         },
  //       }
  //       setLdUser(ldUser);
  //     })
  //     .catch(() => {
  //       setLdUser({ key: 'anonymous' });
  //     });
  // }, [setLdUser]);

  return modalDetails?.data.length > 0 && !modalDetailsLoader ? (
    <Suspense fallback={<Loader tip={``} />}>
      <RouterComponent />
    </Suspense>
  ) : (
    <Loader tip={''} />
  );
};

export default App;
